export default __webpack_public_path__ + "static/media/spinStart.09ba9237.mp3";